import React, { createContext, useEffect, useState } from "react";
import axios from "axios";

export const CartContext = createContext();

const CartProvider = ({ children }) => {

  const [cart, setCart] = useState([]);

  // Fetch cart data from backend when the component mounts
  useEffect(() => {
    getCartData();
  }, []); // Empty dependency array ensures this runs only on mount

  // Function to fetch cart data from the backend
  const getCartData = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}cart/cartdetails`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCart(response?.data); // Set the fetched cart data into the state
    } catch (error) {
      console.error("cart data:", error);
    }
  };

  // Add items into the cart
  const addToCart = async (productId, inputQuantity) => {

    setCart((prevCart) => {
      return prevCart.map((item) => {
        if (item.product.id === productId) {
          const newQuantity = Math.min(
            item.quantity + inputQuantity,
            item.product.stockQty
          );
          return { ...item, quantity: newQuantity };
        }
        return item;
      });
    });

    const token = localStorage.getItem("token");
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}cart/addtocart`,
        {
          productId: productId,
          inputQuantity: inputQuantity,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      getCartData(); // Refresh cart after API call
    } catch (error) {
      console.error("Error adding product to cart:", error);
    }
  };

  // Update items quatity into the cart
  const updateQuantity = (productId, newQuantity) => {

    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product.id === productId
          ? { ...item, quantity: newQuantity }
          : item
      )
    );

    const token = localStorage.getItem("token");
    axios
      .post(
        `${process.env.REACT_APP_API_URL}cart/updatequantity`,
        {
          productId: productId,
          quantity: newQuantity,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        console.info("Quantity updated successfully:", response.data);
      })
      .catch((error) => {
        console.error("Error updating quantity:", error);
      });
  };

  // Remove items from the cart
  const removeFromCart = (productId) => {

    setCart((prevCart) => {
      // Filter out the item with the matching productId
      const updatedCart = prevCart.filter(
        (item) => item.product.id !== productId
      );

      const token = localStorage.getItem("token");

      axios
        .delete(
          `${process.env.REACT_APP_API_URL}cart/deletecart/${productId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          console.info("Product removed from cart:", response.data);
        })
        .catch((error) => {
          console.error("Error removing product from cart:", error);
        });
      return updatedCart;
    });
  };

  const emptyCart = () => {
    setCart([]);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        setCart,
        addToCart,
        removeFromCart,
        updateQuantity,
        emptyCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
